import ConfirmationModal from 'app/components/ConfirmationModal'
import React from 'react'
import {useTestContext} from './TestContext'
import Button from 'app/components/Button'

const NotesSection: React.FC = () => {
  const {
    personnels,
    selectedTest,
    editingNoteIndex,
    editedNoteContent,
    setEditedNoteContent,
    handleEditNote,
    handleSaveEditedNote,
    handleDeleteNote,
    isNoteDeleteModalOpen,
    setIsNoteDeleteModalOpen,
    isDeleting,
    handleConfirmNoteDelete,
    noteSaving,
    currentUser,
    setEditingNoteIndex,
    audits,
    currentAuditContext,
  } = useTestContext()

  if (selectedTest.length === 0) {
    return <div>Loading...</div>
  }
  const test = selectedTest[0]

  const filteredNotes = test.notes ? test.notes.filter((note) => {
    if (currentAuditContext?.auditId) {
      return note.auditId === currentAuditContext.auditId
    }
    if (currentUser?.role === 'Auditor' && audits.length > 0) {
      return note.auditId === audits[0]?.id
    }
    return !note.auditId
  }) : []

  return (
    <>
      <div className='mb-20 mt-8'>
        {filteredNotes.length > 0 ? (
          filteredNotes.map((note, index) => (
            <div className='mt-4 mb-8' key={index}>
              <div className='d-flex align-items-center justify-content-between mb-2'>
                <div className='d-flex align-items-center'>
                  <div className='symbol symbol-40px me-3'>
                    {note.addedUser ? (
                      <span
                        className='symbol-label fs-7 fw-bold'
                        style={{ backgroundColor: '#F5F5F5', border: '1px solid #E5E5E5', borderRadius: '50%' }}
                      >
                        {note.addedUser ? note.addedUser.trim().charAt(0).toUpperCase() : ''}
                      </span>
                    ) : (
                      <span>-</span>
                    )}
                  </div>

                  <div className='d-flex flex-column'>
                    {(() => {
                      const personnel = personnels.find(
                        (p) => p.id === note.addedUserUid || p.uid === note.addedUserUid
                      )
                      return (
                        <span className='text-dark fw-bold fs-6'>
                          {note.addedUser}
                          {personnel && personnel.role && (
                            <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                              {personnel.role}
                            </span>
                          )}
                        </span>
                      )
                    })()}
                    <span className='text-gray-600 fw-semibold text-muted d-block fs-7'>
                      {note.addedDate} {note.addedTime}
                    </span>
                  </div>
                </div>

                <div className='dropdown'>
                  {currentUser?.uid === note?.addedUserUid && (
                    <button
                      className='btn btn-secondary border-0 p-0 m-2'
                      type='button'
                      id='dropdownMenu2'
                      data-bs-toggle='dropdown'
                      aria-haspopup='true'
                      aria-expanded='false'
                    >
                      <img
                        src='/media/buttons/Options.svg'
                        alt='Options'
                        // onClick={toggleDropdown}
                      />
                    </button>
                  )}
                  <ul className='dropdown-menu dropdown-menu-end' aria-labelledby='dropdownMenu2'>
                    <li>
                      <button
                        className='dropdown-item text-hover-primary '
                        type='button'
                        style={{color: '#262626'}}
                        onClick={() => handleEditNote(index, note.note)}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          stroke-width='2'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                          className='icon icon-tabler icons-tabler-outline icon-tabler-edit mx-2 mb-1'
                        >
                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                          <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                          <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                          <path d='M16 5l3 3' />
                        </svg>
                        Edit
                      </button>
                    </li>
                    <li>
                      <button
                        className='dropdown-item text-danger'
                        type='button'
                        onClick={() => handleDeleteNote(index)}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          stroke-width='2'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                          className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-2 mb-1'
                        >
                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                          <path d='M4 7l16 0' />
                          <path d='M10 11l0 6' />
                          <path d='M14 11l0 6' />
                          <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                          <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                        </svg>
                        Delete
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              {editingNoteIndex === index ? (
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  <textarea
                    value={editedNoteContent}
                    onChange={(e) => setEditedNoteContent(e.target.value)}
                    className='form-control'
                  />
                  <div
                    className='d-flex justify-content-end w-100 mt-2 gap-2'
                    style={{width: '100%'}}
                  >
                    <Button btnType='secondary' onClick={() => setEditingNoteIndex(null)}>
                      Close
                    </Button>
                    <button
                      onClick={handleSaveEditedNote}
                      className='btn btn-sm fs-6'
                      onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                        (e.currentTarget.style.backgroundColor = '#148363')
                      }
                      onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                        (e.currentTarget.style.backgroundColor = '#0E9F6E')
                      }
                      style={{
                        backgroundColor: '#0E9F6E',
                        color: '#fff',
                        height: '40px',
                        borderRadius: '4px',
                        marginLeft: '4px',
                        transition: 'background-color 0.3s',
                      }}
                    >
                      {noteSaving ? (
                        <>
                          Saving...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </>
                      ) : (
                        'Save'
                      )}
                    </button>
                  </div>
                </div>
              ) : (
                <div className='card p-4 mb-4 mt-2'>
                  <span className='d-block fs-6 text-gray-900'>
                    <div>{note.note}</div>
                  </span>
                </div>
              )}
            </div>
          ))
        ) : (
          <div
            className='d-flex justify-content-center align-items-center text-center'
            style={{height: '100%'}}
          >
            <div className=''>
              <img
                src='/media/buttons/emptystate.svg'
                alt=''
                className='img-fluid'
                style={{maxWidth: '100px'}}
              />

              <div className=' fs-6'>
                <p style={{fontWeight: 'bold'}}>No notes added yet!!</p>
              </div>
              <p className='fs-7'>Maybe try adding new note for this test</p>
            </div>
          </div>
        )}
      </div>
      <ConfirmationModal
        isModalOpen={isNoteDeleteModalOpen}
        hideModal={() => setIsNoteDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmNoteDelete}
        title='Delete Note'
        message='Are you sure you want to delete this note?'
        isLoading={isDeleting}
        type='delete'
      />
    </>
  )
}

export default NotesSection
